module.exports = __webpack_public_path__ + "img/6.70390f92.png";